module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("I")]), _vm._v("n many respects, this book follows on from several others that I have written in recent years, especially "), _c('i', [_vm._v("Deviant Calvinism: Broadening Reformed Theology ")]), _vm._v("(Fortress, 2014), "), _c('i', [_vm._v("Retrieving Doctrine: Essays in Reform")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("bed Theology ")]), _vm._v("(IVP Academic, 2011), and "), _c('i', [_vm._v("Revisioning Christology: Theology in the Reformed Tradition")]), _vm._v(" (Ashgate, 2011). It is an attempt to provide a Reformed perspective concerning human salvation that seeks to broaden what is thought of as “Calvinistic” when it comes to such matters—not so much by presenting a revision of Calvinism but by attempting to remind modern Calvinists of the breadth of resources at their disposal. It is also a more popular book than the works just mentioned, with far fewer footnotes as well as suggestions for further reading at the end of each chapter. The hope is that it will appeal to a broader audience for whom these issues are important and pressing ones.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("For encouragement of this project and support along the way, I would like to thank Claire Crisp, Michael Thompson, and David Bratt, as well as David Congdon, my editor at IVP Academic. Jordan Wessling deserves particular thanks for reading a number of the chapters in draft. I also want to thank Robin Parry, whose remarks on an earlier version of chapter four saved me from several mistakes. He has been a fast friend through thick and thin over the years. This book is dedicated to him as a token of my gratitude and esteem for him and for his work.")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0